/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import InvoiceService from 'src/services/invoice.service';

export const useAddInvoice = (): UseMutationResult<any, Error, { invoice: FormData }, void> =>
  useMutation((data: { invoice: FormData }) => InvoiceService.addInvoice(data.invoice), {
    onSuccess: () => {
      AlertAdapter('Invoice has been created.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useUpdateInvoice = (): UseMutationResult<any, Error, { id: string; invoice: FormData }, void> =>
  useMutation(({ id, invoice }: { id: string; invoice: FormData }) => InvoiceService.updateInvoice(id, invoice), {
    onSuccess: () => {
      AlertAdapter('Invoice has been updated.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useApproveInvocie = (): UseMutationResult<any, Error, { invoiceId: string; invoice: any }, void> =>
  useMutation(
    ({ invoiceId, invoice }: { invoiceId: string; invoice: any }) => InvoiceService.approveInvocie(invoiceId, invoice),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useRejectInvocie = (): UseMutationResult<any, Error, { invoiceId: string; invoice: any }, void> =>
  useMutation(
    ({ invoiceId, invoice }: { invoiceId: string; invoice: any }) => InvoiceService.rejectInvocie(invoiceId, invoice),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useDeleteInvocie = (): UseMutationResult<any, Error, { invoiceId: string; invoice: any }, void> =>
  useMutation(
    ({ invoiceId, invoice }: { invoiceId: string; invoice: any }) => InvoiceService.deleteInvocie(invoiceId, invoice),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
